import React from 'react';

const renderBlock = (block, index) => {
  if (block.type === 'h3') return <h3 key={index}>{block.text}</h3>;
  if (block.type === 'list') {
    return (
      <ul key={index}>
        {block.items.map(([label, text], itemIndex) => (
          <li key={itemIndex}><strong>{label}</strong>{text}</li>
        ))}
      </ul>
    );
  }
  if (block.type === 'plainList') {
    return (
      <ul key={index}>
        {block.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}
      </ul>
    );
  }
  return <p key={index}>{block.text}</p>;
};

const LegalDocument = ({ document, compact = false }) => (
  <article className={compact ? 'legal-document legal-document--compact' : 'legal-document'}>
    <h1>{document.title}</h1>
    <div className="legal-document__meta">{document.meta}</div>
    {document.sections.map((section, index) => (
      <section key={index}>
        {section.title && <h2>{section.title}</h2>}
        {section.blocks.map(renderBlock)}
      </section>
    ))}
  </article>
);

export default LegalDocument;
